import Vue from 'vue';

import router from '@/router';
import store from '@/store';
import globals from '@/globals';
import layout from '@/components/globals/layout.vue';


Vue.config.productionTip = false;

globals.initialize();

const app = new Vue({
  router,
  render(createElement) {
    return createElement(layout);
  },
  store
});

app.$mount('#app');


export default app;
